import { Api } from '../helpers';

const timelineModel = {
  getTimelineData(params) {
    const queryParams = params;
    const path = 'order/get_progress';
    return Api.get({ path, queryParams });
  },

  getBatchedDetails(params) {
    const queryParams = params;
    const path = 'order/get_batched_details';
    return Api.get({ path, queryParams });
  },
};

export default timelineModel;
